import {
	AvatarFallback,
	AvatarImage,
	Root as AvatarPrimitiveRoot
} from '@radix-ui/react-avatar'
import { cn } from '@/helpers/utils'

interface AvatarProps {
	name: string
	imageUrl: string
	size?: 'sm' | 'md' | 'lg'
	className?: string
}

const sizeStyles = {
	sm: 'h-6 w-6 text-xs',
	md: 'h-10 w-10 text-xl',
	lg: 'h-14 w-14 text-[28px]'
}

const getInitials = (name: string): string => {
	const initials = name.match(/\b\w/g)
	if (initials) {
		return initials.length <= 2
			? initials.join('')
			: `${initials[0]}${initials.at(-1)}`
	}

	return ''
}

export const Avatar = ({
	name,
	imageUrl,
	size = 'md',
	className
}: AvatarProps) => (
	<AvatarPrimitiveRoot
		className={cn(
			'inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-full bg-neutral-100 align-middle',
			sizeStyles[size],
			className
		)}
	>
		<AvatarImage alt={name} src={imageUrl} />
		<AvatarFallback delayMs={600}>{getInitials(name)}</AvatarFallback>
	</AvatarPrimitiveRoot>
)

Avatar.displayName = 'Avatar'
